/* eslint-disable no-prototype-builtins */
import React, { useRef } from 'react';
import { ReactSVG } from 'react-svg';
import { useSelector, useDispatch } from 'react-redux';
import MenuIcon from 'Assets/images/pages/web-chat/menu.svg';
import {
  func, shape,
} from 'prop-types';
import { contextBubbleMenuChange, contextBubbleMenuHide } from 'Redux/modules/webChat/actions';
import { CONSULT_ACCEPTED, CONTEXT_MENU_CONSULT_OPTIONS } from 'Constants/consults';
import ContextMenu from '../../ContextMenu/ContextMenu';
import css from './BubbleMenu.less';

const BubbleMenu = ({
  conversationActive,
  openPrescriptionModal,
  openReferralMemo,
  openMemoRandum,
  openPOS,
  openMedicalCertificate,
}) => {
  const dispatch = useDispatch();
  const menuRef = useRef();
  const groupId = conversationActive?.id;
  const { contextMenu } = useSelector(state => state.webChat);
  const { bubbleMenuContext } = contextMenu;
  const currentBubble = bubbleMenuContext?.hasOwnProperty(groupId) ? bubbleMenuContext[groupId] : undefined;
  const {
    type,
  } = contextMenu;
  const { latestConsult: { status } } = conversationActive;
  const hasDisableMenu = status !== CONSULT_ACCEPTED;
  const style = hasDisableMenu ? {
    cursor: 'default',
    opacity: 0.5,
  } : {};

  const changeContextMenu = (ctype, data, pushHistory) => {
    dispatch(contextBubbleMenuChange({
      groupId,
      conversationActive,
      data: {
        type: ctype,
        isShow: true,
        data: {
          ...data,
        },
        pushHistory,
      },
    }));
  };

  const handleOpenMenu = () => {
    dispatch(contextBubbleMenuChange({
      groupId,
      conversationActive,
      data: {
        type: CONTEXT_MENU_CONSULT_OPTIONS,
        isShow: !currentBubble?.isShow,
        data: {
          consultId: conversationActive.latestConsult.id,
        },
      },
    }));
  };
  const closeContextMenu = () => {
    dispatch(contextBubbleMenuHide(groupId));
  };

  return (
    <div style={{ position: 'static' }}>
      <div onClick={hasDisableMenu ? null : handleOpenMenu}>
        <ReactSVG className={css.menuBtn} style={style} src={MenuIcon} />
      </div>
      {currentBubble?.isShow && (
        <div className="bubble-menu" ref={menuRef}>
          <ContextMenu
            type={type}
            closeMenu={closeContextMenu}
            changeContextMenu={changeContextMenu}
            contextMenu={currentBubble}
            openFinishConsult={() => { }}
            openPrescriptionModal={openPrescriptionModal}
            openReferralMemo={openReferralMemo}
            openMemoRandum={openMemoRandum}
            openPOS={openPOS}
            openMedicalCertificate={openMedicalCertificate}
            conversation={conversationActive}
            isMinimize
          />
        </div>
      )}
    </div>
  );
};

BubbleMenu.propTypes = {
  conversationActive: shape({}).isRequired,
  openMedicalCertificate: func.isRequired,
  openPrescriptionModal: func.isRequired,
  openReferralMemo: func.isRequired,
  openPOS: func.isRequired,
  openMemoRandum: func.isRequired,
};

BubbleMenu.defaultProp = {
};

export default BubbleMenu;
